// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_2XNlpKgSVFiOKIt-VY69M1"};